import React, { useMemo } from 'react';
import { Button, Form, Image, Stack } from 'react-bootstrap';
import ReactSelect, { SingleValue } from 'react-select';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { jobStatus, S3_URL } from 'constants/index';
import { HiringBoardInterface } from 'constants/interfaces';
import { formatLocation } from 'utils';
import ChatBtn from 'components/Common/ActionButton/ChatBtn';
import { useNavigate } from 'react-router-dom';
import './styles.scss';
import useTranslate from 'hooks/useTranslate';

interface UserDetailInterface {
	about: 'string';
	cityName: 'string';
	countryName: 'string';
	designation: 'string';
	id: 'string';
	profilePicture: 'string';
	stateName: 'string';
	userId: 'string';
	userName: 'string';
}

interface UserCardProps {
	data: UserDetailInterface;
	changeStatus: (data: SingleValue<HiringBoardInterface>, id: 'string') => void;
	currentJobStatus: string;
	rejectCandidate: any;
}

const UserCard: React.FC<UserCardProps> = ({
	data: { userName, userId, cityName, countryName, stateName, designation, id, profilePicture },
	changeStatus,
	currentJobStatus,
	rejectCandidate,
}) => {
	const navigate = useNavigate();
	const { translate } = useTranslate();
	const address = useMemo(() => formatLocation(cityName, stateName, countryName), []);

	const options = jobStatus.filter((option: any) => {
		const index = jobStatus.findIndex((status: any) => status.value === currentJobStatus);
		return jobStatus.indexOf(option) > index;
	});

	const handleClick = () => {
		rejectCandidate(id, currentJobStatus);
	};

	return (
		<Stack className="applicant-card bg-white">
			<div
				onClick={() => navigate(`/seeker/profile/${userId}`)}
				className="d-flex align-items-center details-section gap-2"
			>
				<div className="profile">
					<Image
						onClick={() => {
							navigate(`/seeker/profile/${userId}`);
						}}
						style={{ cursor: 'pointer' }}
						src={`${S3_URL}${profilePicture}`}
						onError={({ currentTarget }) => {
							currentTarget.onerror = null;
							currentTarget.src = IMAGE_PATHS.UserDefault;
						}}
						alt="profile"
						className="w-100 h-100 rounded-circle"
						loading="lazy"
					/>
				</div>
				<div className="flex-1">
					<h5
						onClick={() => {
							navigate(`/seeker/profile/${userId}`);
						}}
						style={{ cursor: 'pointer' }}
						className="fw-bold mb-1"
					>
						{userName}
					</h5>
					<p className="mb-0">{designation}</p>
				</div>
			</div>
			<div className="d-flex align-items-center gap-2">
				<i className="ri-map-pin-line map-icon"></i>
				<h6 className="fw-bold mb-0">{address}</h6>
			</div>
			{currentJobStatus !== 'offered' && (
				<div className="move-list">
					<Form.Group className="position-relative overflow-visible">
						<ReactSelect
							isSearchable
							options={options}
							onChange={(e: any) => {
								changeStatus(e, id);
							}}
							name="skills"
							placeholder="Move To"
							className="form-react-select"
							classNamePrefix="select"
						/>
					</Form.Group>
				</div>
			)}
			<div className="d-flex align-items-center gap-3">
				{currentJobStatus !== 'offered' && (
					<Button onClick={handleClick} className="gray-transparent-btn rounded-pill lh-1">
						{translate('Button.reject')}
					</Button>
				)}
				<ChatBtn
					className='"filled-btn rounded-pill lh-1"'
					receiverId={Number(userId)}
					mode="btn"
				/>
			</div>
		</Stack>
	);
};

export default UserCard;
